import { Box, Stack } from '@mui/material';
import { getImageByTheme } from '../../utilities/ArticleCoverImageUtilities';
import VideoChip from '../ArticleCard/VideoChip';
import { defaultCoverImageAspectRatio } from '../../types/types';

interface ArticleCoverImageProps {
  readonly category?: string;
  readonly src?: string;
  readonly aspectRatio?: number;
  readonly height?: string;
  readonly isVideo?: boolean;
}

export default function ArticleCoverImage({
  category,
  src = undefined,
  aspectRatio = defaultCoverImageAspectRatio,
  height = 'auto',
  isVideo = false,
}: ArticleCoverImageProps) {
  const coverImagePath = '/themecover/' + getImageByTheme(category);

  return (
    <Stack
      sx={{
        position: 'relative',
      }}
    >
      {isVideo && (
        <Box style={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}>
          <VideoChip dark />
        </Box>
      )}

      <img
        src={src ?? coverImagePath}
        alt={category ?? 'category cover'}
        style={{
          height,
          maxWidth: '100%',
          objectFit: 'cover',
          aspectRatio: aspectRatio,
          overflow: 'hidden',
        }}
        data-testid='article-cover-image'
      />
    </Stack>
  );
}
